"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMENT_TEXT_LIMIT = exports.AVATAR_PREFIX_PROD = exports.AVATAR_PREFIX_STAGE = exports.CC_STORAGE_URL_ID_PREFIX_PROD = exports.CC_STORAGE_URL_ID_PREFIX_STAGE = exports.GUEST_SESSION_REFRESH_LIMIT = exports.ANNOTATION_COLOR_PALETE = exports.UNMAPPED_GLOBAL_ID = exports.JUST_EDITED = exports.JUST_ADDED = exports.REPLY_BEFORE_SIGNIN = exports.COMMENT_BEFORE_SIGNIN = exports.MENTION_REGEX = exports.MENTION_PUNCTUATION = exports.TEXT_INPUT_DEBOUNCE_VALUE = exports.TOAST_TIMEOUT = exports.SUBMIT_COMPONENT_ID = exports.LIST_COMPONENT_ID = exports.FULL_COMPONENT_ID = exports.ANNOTATION_CLASS_PREFIX = exports.ANNOTATION_MASK_COMPONENT_ID = exports.ANNOTATION_COMPONENT_ID = exports.DEFAULT_GUEST_NAME_LIMIT = exports.KEY_CODES = exports.INGEST_INITIAL_STATE = exports.INGEST_PROJECT_VALUE = exports.USER_TOKEN_PREFIX = exports.USER_ID_PREFIX = exports.ASSET_PREFIX_CCX = exports.ASSET_PREFIX = exports.UPDATE_ANNOTATION = exports.POST_REPLY = exports.FETCH_COLLABORATORS = exports.CONTEXT_CREATE_GUEST_USER_SESSION = exports.COMMENTS_RESOLVE = exports.COMMENTS_POST = exports.COMMENTS_OPEN = exports.COMMENTS_GET = exports.COMMENTS_EDIT = exports.COMMENTS_DELETE = exports.COMMENTS_BATCH_REMAP = exports.CONTEXT_RESET_GUEST_USER_SESSION = exports.CONTEXT_SET_GUEST_USER_SESSION_STATE = exports.DELTA_UPDATE = exports.COMMENTS_REMAP_COMMENT_NODES = exports.ANNOTATION_SET_SELECTED_ANNOTATION_ID = exports.ANNOTATION_SET_TOUCH_PRESSED = exports.ANNOTATION_SET_DRAWING_NODE = exports.ANNOTATION_SET_HOVERED_ANNOTATION = exports.SET_ANNOTATING_COMMENT_ID = exports.CONTEXT_SET_UNMAPPED_VIEW = exports.CONTEXT_SET_COMMENTS_LIST_MINIMIZED = exports.CONTEXT_SAVE_FOCUSED_INPUT_INFO = exports.CONTEXT_SET_GUEST_USER_LOGIN_TOAST_INFO = exports.CONTEXT_SET_SHOW_COMMENT_ID = exports.CONTEXT_SET_CLICKED_ANNOTATION = exports.CONTEXT_SET_ANNOTATION_MODE = exports.CONTEXT_SAVE_IMAGE_COORDINATES_INFO = exports.CONTEXT_SAVE_ANNOTATION_COLOR = exports.CONTEXT_SAVE_ANNOTATION_LOCATION = exports.CONTEXT_REGISTER_SECTION_ID = exports.CONTEXT_CLEAR = exports.COMMENTS_TOGGLE_REPLY = exports.COMMENTS_TOGGLE_RESOLVED = exports.COMMENTS_SET_RECENT_ACTIVITY = exports.COMMENTS_SET_SHOW_ANNOTATIONS = exports.COMMENTS_PROPOSE_FOR_DELETE = exports.COMMENTS_FILTER_USERS = exports.COMMENTS_FILTER_TOGGLE = exports.COMMENTS_FILTER_TIME = exports.COMMENTS_FILTER_CLEAR = exports.COMMENTS_CLEAR_ERROR = exports.COMMENTS_CLEAR = exports.COMMENTS_CANCEL_FOR_DELETE = exports.COMMENTS_ADD_DIRTY_COMMENT_TO_ARTBOARD = exports.PREFIX = void 0;

var _helpers = require("../actions/helpers");

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var PREFIX = 'CCX-COMMENTS'; // Async actions helper

exports.PREFIX = PREFIX;
var commentsAsyncHelper = (0, _helpers.asyncMessageFactory)(PREFIX); // Generic Static Synchronous Actions

var COMMENTS_ADD_DIRTY_COMMENT_TO_ARTBOARD = "".concat(PREFIX, ".COMMENTS_ADD_DIRTY_COMMENT_TO_ARTBOARD");
exports.COMMENTS_ADD_DIRTY_COMMENT_TO_ARTBOARD = COMMENTS_ADD_DIRTY_COMMENT_TO_ARTBOARD;
var COMMENTS_CANCEL_FOR_DELETE = "".concat(PREFIX, ".COMMENTS_CANCEL_FOR_DELETE");
exports.COMMENTS_CANCEL_FOR_DELETE = COMMENTS_CANCEL_FOR_DELETE;
var COMMENTS_CLEAR = "".concat(PREFIX, ".COMMENTS_CLEAR");
exports.COMMENTS_CLEAR = COMMENTS_CLEAR;
var COMMENTS_CLEAR_ERROR = "".concat(PREFIX, ".COMMENTS_CLEAR_ERROR");
exports.COMMENTS_CLEAR_ERROR = COMMENTS_CLEAR_ERROR;
var COMMENTS_FILTER_CLEAR = "".concat(PREFIX, ".COMMENTS_FILTER_CLEAR");
exports.COMMENTS_FILTER_CLEAR = COMMENTS_FILTER_CLEAR;
var COMMENTS_FILTER_TIME = "".concat(PREFIX, ".COMMENTS_FILTER_TIME");
exports.COMMENTS_FILTER_TIME = COMMENTS_FILTER_TIME;
var COMMENTS_FILTER_TOGGLE = "".concat(PREFIX, ".COMMENTS_FILTER_TOGGLE");
exports.COMMENTS_FILTER_TOGGLE = COMMENTS_FILTER_TOGGLE;
var COMMENTS_FILTER_USERS = "".concat(PREFIX, ".COMMENTS_FILTER_USERS");
exports.COMMENTS_FILTER_USERS = COMMENTS_FILTER_USERS;
var COMMENTS_PROPOSE_FOR_DELETE = "".concat(PREFIX, ".COMMENTS_PROPOSE_FOR_DELETE");
exports.COMMENTS_PROPOSE_FOR_DELETE = COMMENTS_PROPOSE_FOR_DELETE;
var COMMENTS_SET_SHOW_ANNOTATIONS = "".concat(PREFIX, ".COMMENTS_SET_SHOW_ANNOTATIONS");
exports.COMMENTS_SET_SHOW_ANNOTATIONS = COMMENTS_SET_SHOW_ANNOTATIONS;
var COMMENTS_SET_RECENT_ACTIVITY = "".concat(PREFIX, ".COMMENTS_SET_RECENT_ACTIVITY");
exports.COMMENTS_SET_RECENT_ACTIVITY = COMMENTS_SET_RECENT_ACTIVITY;
var COMMENTS_TOGGLE_RESOLVED = "".concat(PREFIX, ".COMMENTS_TOGGLE_RESOLVED");
exports.COMMENTS_TOGGLE_RESOLVED = COMMENTS_TOGGLE_RESOLVED;
var COMMENTS_TOGGLE_REPLY = "".concat(PREFIX, ".COMMENTS_TOGGLE_REPLY");
exports.COMMENTS_TOGGLE_REPLY = COMMENTS_TOGGLE_REPLY;
var CONTEXT_CLEAR = "".concat(PREFIX, ".CONTEXT_CLEAR");
exports.CONTEXT_CLEAR = CONTEXT_CLEAR;
var CONTEXT_REGISTER_SECTION_ID = "".concat(PREFIX, ".CONTEXT_REGISTER_SECTION_ID");
exports.CONTEXT_REGISTER_SECTION_ID = CONTEXT_REGISTER_SECTION_ID;
var CONTEXT_SAVE_ANNOTATION_LOCATION = "".concat(PREFIX, ".CONTEXT_SAVE_ANNOTATION_LOCATION");
exports.CONTEXT_SAVE_ANNOTATION_LOCATION = CONTEXT_SAVE_ANNOTATION_LOCATION;
var CONTEXT_SAVE_ANNOTATION_COLOR = "".concat(PREFIX, ".CONTEXT_SAVE_ANNOTATION_COLOR");
exports.CONTEXT_SAVE_ANNOTATION_COLOR = CONTEXT_SAVE_ANNOTATION_COLOR;
var CONTEXT_SAVE_IMAGE_COORDINATES_INFO = "".concat(PREFIX, ".CONTEXT_SAVE_IMAGE_COORDINATES_INFO");
exports.CONTEXT_SAVE_IMAGE_COORDINATES_INFO = CONTEXT_SAVE_IMAGE_COORDINATES_INFO;
var CONTEXT_SET_ANNOTATION_MODE = "".concat(PREFIX, ".CONTEXT_SET_ANNOTATION_MODE");
exports.CONTEXT_SET_ANNOTATION_MODE = CONTEXT_SET_ANNOTATION_MODE;
var CONTEXT_SET_CLICKED_ANNOTATION = "".concat(PREFIX, ".CONTEXT_SET_CLICKED_ANNOTATION");
exports.CONTEXT_SET_CLICKED_ANNOTATION = CONTEXT_SET_CLICKED_ANNOTATION;
var CONTEXT_SET_SHOW_COMMENT_ID = "".concat(PREFIX, ".CONTEXT_SET_SHOW_COMMENT_ID");
exports.CONTEXT_SET_SHOW_COMMENT_ID = CONTEXT_SET_SHOW_COMMENT_ID;
var CONTEXT_SET_GUEST_USER_LOGIN_TOAST_INFO = "".concat(PREFIX, ".CONTEXT_SET_GUEST_USER_LOGIN_TOAST_INFO");
exports.CONTEXT_SET_GUEST_USER_LOGIN_TOAST_INFO = CONTEXT_SET_GUEST_USER_LOGIN_TOAST_INFO;
var CONTEXT_SAVE_FOCUSED_INPUT_INFO = "".concat(PREFIX, ".CONTEXT_SAVE_FOCUSED_INPUT_INFO");
exports.CONTEXT_SAVE_FOCUSED_INPUT_INFO = CONTEXT_SAVE_FOCUSED_INPUT_INFO;
var CONTEXT_SET_COMMENTS_LIST_MINIMIZED = "".concat(PREFIX, ".CONTEXT_SET_COMMENTS_LIST_MINIMIZED");
exports.CONTEXT_SET_COMMENTS_LIST_MINIMIZED = CONTEXT_SET_COMMENTS_LIST_MINIMIZED;
var CONTEXT_SET_UNMAPPED_VIEW = "".concat(PREFIX, ".CONTEXT_SET_UNMAPPED_VIEW");
exports.CONTEXT_SET_UNMAPPED_VIEW = CONTEXT_SET_UNMAPPED_VIEW;
var SET_ANNOTATING_COMMENT_ID = "".concat(PREFIX, ".SET_ANNOTATING_COMMENT_ID");
exports.SET_ANNOTATING_COMMENT_ID = SET_ANNOTATING_COMMENT_ID;
var ANNOTATION_SET_HOVERED_ANNOTATION = "".concat(PREFIX, ".ANNOTATION_SET_HOVERED_ANNOTATION");
exports.ANNOTATION_SET_HOVERED_ANNOTATION = ANNOTATION_SET_HOVERED_ANNOTATION;
var ANNOTATION_SET_DRAWING_NODE = "".concat(PREFIX, ".ANNOTATION_SET_DRAWING_NODE");
exports.ANNOTATION_SET_DRAWING_NODE = ANNOTATION_SET_DRAWING_NODE;
var ANNOTATION_SET_TOUCH_PRESSED = "".concat(PREFIX, ".ANNOTATION_SET_TOUCH_PRESSED");
exports.ANNOTATION_SET_TOUCH_PRESSED = ANNOTATION_SET_TOUCH_PRESSED;
var ANNOTATION_SET_SELECTED_ANNOTATION_ID = "".concat(PREFIX, ".ANNOTATION_SET_SELECTED_ANNOTATION_ID");
exports.ANNOTATION_SET_SELECTED_ANNOTATION_ID = ANNOTATION_SET_SELECTED_ANNOTATION_ID;
var COMMENTS_REMAP_COMMENT_NODES = "".concat(PREFIX, ".COMMENTS_REMAP_COMMENT_NODES");
exports.COMMENTS_REMAP_COMMENT_NODES = COMMENTS_REMAP_COMMENT_NODES;
var DELTA_UPDATE = "".concat(PREFIX, ".DELTA_UPDATE");
exports.DELTA_UPDATE = DELTA_UPDATE;
var CONTEXT_SET_GUEST_USER_SESSION_STATE = "".concat(PREFIX, ".CONTEXT_SET_GUEST_USER_SESSION_STATE");
exports.CONTEXT_SET_GUEST_USER_SESSION_STATE = CONTEXT_SET_GUEST_USER_SESSION_STATE;
var CONTEXT_RESET_GUEST_USER_SESSION = "".concat(PREFIX, ".CONTEXT_RESET_GUEST_USER_SESSION"); // Async Actions

exports.CONTEXT_RESET_GUEST_USER_SESSION = CONTEXT_RESET_GUEST_USER_SESSION;
var COMMENTS_BATCH_REMAP = commentsAsyncHelper('COMMENTS_BATCH_REMAP');
exports.COMMENTS_BATCH_REMAP = COMMENTS_BATCH_REMAP;
var COMMENTS_DELETE = commentsAsyncHelper('COMMENTS_DELETE');
exports.COMMENTS_DELETE = COMMENTS_DELETE;
var COMMENTS_EDIT = commentsAsyncHelper('COMMENTS_EDIT');
exports.COMMENTS_EDIT = COMMENTS_EDIT;
var COMMENTS_GET = commentsAsyncHelper('COMMENTS_GET');
exports.COMMENTS_GET = COMMENTS_GET;
var COMMENTS_OPEN = commentsAsyncHelper('COMMENTS_OPEN');
exports.COMMENTS_OPEN = COMMENTS_OPEN;
var COMMENTS_POST = commentsAsyncHelper('COMMENTS_POST');
exports.COMMENTS_POST = COMMENTS_POST;
var COMMENTS_RESOLVE = commentsAsyncHelper('COMMENTS_RESOLVE');
exports.COMMENTS_RESOLVE = COMMENTS_RESOLVE;
var CONTEXT_CREATE_GUEST_USER_SESSION = commentsAsyncHelper('CONTEXT_CREATE_GUEST_USER_SESSION');
exports.CONTEXT_CREATE_GUEST_USER_SESSION = CONTEXT_CREATE_GUEST_USER_SESSION;
var FETCH_COLLABORATORS = commentsAsyncHelper('FETCH_COLLABORATORS');
exports.FETCH_COLLABORATORS = FETCH_COLLABORATORS;
var POST_REPLY = commentsAsyncHelper('POST_REPLY');
exports.POST_REPLY = POST_REPLY;
var UPDATE_ANNOTATION = commentsAsyncHelper('UPDATE_ANNOTATION');
exports.UPDATE_ANNOTATION = UPDATE_ANNOTATION;
var ASSET_PREFIX = 'urn:aaid:';
exports.ASSET_PREFIX = ASSET_PREFIX;
var ASSET_PREFIX_CCX = "".concat(ASSET_PREFIX, "sc:");
exports.ASSET_PREFIX_CCX = ASSET_PREFIX_CCX;
var USER_ID_PREFIX = 'urn:uuid:';
exports.USER_ID_PREFIX = USER_ID_PREFIX;
var USER_TOKEN_PREFIX = 'Bearer';
exports.USER_TOKEN_PREFIX = USER_TOKEN_PREFIX;
var INGEST_PROJECT_VALUE = 'comment-service';
exports.INGEST_PROJECT_VALUE = INGEST_PROJECT_VALUE;
var INGEST_INITIAL_STATE = {
  event: {
    category: 'WEB',
    language: null,
    offline: false,
    user_guid: null
  },
  source: {
    client_id: 'CCXComments1',
    name: 'Commenting Service UI',
    platform: 'Web',
    version: null
  }
};
exports.INGEST_INITIAL_STATE = INGEST_INITIAL_STATE;
var KEY_CODES = {
  DOWN: 40,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  TAB: 9,
  UP: 38
};
exports.KEY_CODES = KEY_CODES;
var DEFAULT_GUEST_NAME_LIMIT = 256; // 256 characters

exports.DEFAULT_GUEST_NAME_LIMIT = DEFAULT_GUEST_NAME_LIMIT;
var ANNOTATION_COMPONENT_ID = 'ccx-annotations-overlay';
exports.ANNOTATION_COMPONENT_ID = ANNOTATION_COMPONENT_ID;
var ANNOTATION_MASK_COMPONENT_ID = 'ccx-annotations-mask';
exports.ANNOTATION_MASK_COMPONENT_ID = ANNOTATION_MASK_COMPONENT_ID;
var ANNOTATION_CLASS_PREFIX = 'ccx-annotation';
exports.ANNOTATION_CLASS_PREFIX = ANNOTATION_CLASS_PREFIX;
var FULL_COMPONENT_ID = 'ccx-comments-full';
exports.FULL_COMPONENT_ID = FULL_COMPONENT_ID;
var LIST_COMPONENT_ID = 'ccx-comments-list';
exports.LIST_COMPONENT_ID = LIST_COMPONENT_ID;
var SUBMIT_COMPONENT_ID = 'ccx-comments-submit';
exports.SUBMIT_COMPONENT_ID = SUBMIT_COMPONENT_ID;
var TOAST_TIMEOUT = 5000;
exports.TOAST_TIMEOUT = TOAST_TIMEOUT;
var TEXT_INPUT_DEBOUNCE_VALUE = 200; // in milliseconds

exports.TEXT_INPUT_DEBOUNCE_VALUE = TEXT_INPUT_DEBOUNCE_VALUE;
var MENTION_PUNCTUATION = ['', '.', '?', ',', '!', ':', ';', "'"];
exports.MENTION_PUNCTUATION = MENTION_PUNCTUATION;
var MENTION_REGEX = /(?!\b)@(?:[^\s]|$)/g;
exports.MENTION_REGEX = MENTION_REGEX;
var COMMENT_BEFORE_SIGNIN = 'ccx-comment-before-signin';
exports.COMMENT_BEFORE_SIGNIN = COMMENT_BEFORE_SIGNIN;
var REPLY_BEFORE_SIGNIN = 'ccx-reply-before-signin';
exports.REPLY_BEFORE_SIGNIN = REPLY_BEFORE_SIGNIN;
var JUST_ADDED = 'justAdded';
exports.JUST_ADDED = JUST_ADDED;
var JUST_EDITED = 'justEdited';
exports.JUST_EDITED = JUST_EDITED;
var UNMAPPED_GLOBAL_ID = '_UNMAPPED';
exports.UNMAPPED_GLOBAL_ID = UNMAPPED_GLOBAL_ID;
var ANNOTATION_COLOR_PALETE = [{
  hex: '#b80000',
  name: 'red'
}, {
  hex: '#db3e00',
  name: 'orange'
}, {
  hex: '#fccb00',
  name: 'yellow'
}, {
  hex: '#008b02',
  name: 'green'
}, {
  hex: '#006b76',
  name: 'deepCyan'
}, {
  hex: '#1273de',
  name: 'blue'
}, {
  hex: '#004dcf',
  name: 'navyBlue'
}, {
  hex: '#5300eb',
  name: 'purple'
}, {
  hex: '#eb9694',
  name: 'lightRed'
}, {
  hex: '#fad0c3',
  name: 'lightOrange'
}, {
  hex: '#fef3bd',
  name: 'lightYellow'
}, {
  hex: '#c1e1c5',
  name: 'lightGreen'
}, {
  hex: '#bedadc',
  name: 'lightDeepCyan'
}, {
  hex: '#c4def6',
  name: 'lightBlue'
}, {
  hex: '#bed3f3',
  name: 'lightNavyBlue'
}, {
  hex: '#d4c4fb',
  name: 'lightPurple'
}];
exports.ANNOTATION_COLOR_PALETE = ANNOTATION_COLOR_PALETE;
var GUEST_SESSION_REFRESH_LIMIT = 3;
exports.GUEST_SESSION_REFRESH_LIMIT = GUEST_SESSION_REFRESH_LIMIT;
var CC_STORAGE_URL_ID_PREFIX_STAGE = 'https://cc-api-storage-stage.adobe.io/id/';
exports.CC_STORAGE_URL_ID_PREFIX_STAGE = CC_STORAGE_URL_ID_PREFIX_STAGE;
var CC_STORAGE_URL_ID_PREFIX_PROD = 'https://cc-api-storage.adobe.io/id/';
exports.CC_STORAGE_URL_ID_PREFIX_PROD = CC_STORAGE_URL_ID_PREFIX_PROD;
var AVATAR_PREFIX_STAGE = 'https://ab-stg.adobe-identity.com/api/avatars/50/';
exports.AVATAR_PREFIX_STAGE = AVATAR_PREFIX_STAGE;
var AVATAR_PREFIX_PROD = 'https://ab.adobe-identity.com/api/avatars/50/';
exports.AVATAR_PREFIX_PROD = AVATAR_PREFIX_PROD;
var COMMENT_TEXT_LIMIT = 2500;
exports.COMMENT_TEXT_LIMIT = COMMENT_TEXT_LIMIT;